import {Group} from 'three'

import type {BrandedDividerRegistration} from '../../components/WebGLContext/WebGLContext.types'
import {getRenderer} from '../_commonObjects'
import {CORNER_RADIUS} from '../modules/cube/_config'
import RoundedCubeGeometry from '../modules/cube/RoundedCubeGeometry'
import Layout from './Layout'

export default class BrandedDivider {
  group: Group = new Group()
  layouts: Layout[] = []
  _cubeGeometry: RoundedCubeGeometry
  constructor() {
    // const orbitControls = new OrbitControls(this.camera, document.body);
    // orbitControls.enabled = false;
    this._cubeGeometry = new RoundedCubeGeometry(CORNER_RADIUS, 8)
  }

  updateRegisterBrandedDivider(brandedDividers: BrandedDividerRegistration[]) {
    // Check existing group and remove those not in dithers
    // If new dither registrations are found, add group for them
    // This method can be expanded based on how dithers are linked to group
    const existingIds = this.layouts.map(layout => layout.group.userData.ditherId)
    const newIds = brandedDividers.map(brandedDivider => brandedDivider.id)

    // Remove group not in newIds
    this.layouts = this.layouts.filter(layout => {
      if (!newIds.includes(layout.group.userData.ditherId)) {
        this.group.remove(layout.group)
        return false
      }
      return true
    })

    // Add new groups for newIds
    brandedDividers.forEach(brandedDivider => {
      if (!existingIds.includes(brandedDivider.id)) {
        this.createScene(brandedDivider.element, brandedDivider.id, brandedDivider.params)
      }
    })

    this.resize()
    setTimeout(() => {
      this.resize()
    }, 100)
  }

  async createScene(element: HTMLElement, id: string, params: any) {
    const renderer = getRenderer()
    if (!renderer) return
    const layout = new Layout(this._cubeGeometry)

    this.group.add(layout.group)
    this.layouts.push(layout)
    await layout.createScene(element, id, params)
  }

  resize() {
    this.layouts.forEach(layout => {
      layout.resize()
    })
  }

  update(time: number, frameDeltaScroll: number, frameDelta: number) {
    this.layouts.forEach(layout => {
      layout.update(frameDelta)
    })
  }
}
